import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import {
  roleList,
  stuacademicyearlist,
  stuclasslist,
  studeptlist,
  studivisionlist,
  wtypelist,
} from "../../../services/master";
import { academylist, workerfilter } from "../../../services/admin";
import Select from "react-select";
import { toast } from "react-toastify";
import { studentfilter, studentviewdetail, stuidcardissue } from "../../../services/student";
import moment from "moment";
import { teacherfilter } from "../../../services/teacher";

export default function Addidcard() {
  const [idtype, setIdType] = useState("");
  const [rlist, setRList] = useState([]);

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [ayear, setAYear] = useState("");
  const [alist, setAList] = useState([]);

  const [stucls, setStuCls] = useState("");
  const [clist, setCList] = useState([]);

  const [studiv, setStuDiv] = useState("");
  const [dlist, setDList] = useState([]);

  const [stuid, setStuId] = useState("");
  const [stulist, setStuList] = useState([]);
  const [slist, setSList] = useState([]);
  const [spath, setSPath] = useState("");


  const [dept, setDept] = useState("");
  const [dplist, setDeptList] = useState([]);
  const [tlist, setTList] = useState([]);
  const [tealist, setTeaList] = useState([]);

  const [wtype, setWType] = useState("");
  const [wlist, setWtList] = useState([]);

  const [wolist, setWoList] = useState([]);
  const [Worlist, setWorList] = useState([]);


  useEffect(() => {
    roleList().then((res) => {
      if (res.status === true) {
        setRList(res.data);
      }
    });
    stuclasslist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].class_name,
            });
          }
          setCList(arr);
        }
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setDList(arr);
        }
      }
    });
   

    if (localStorage.getItem("Role") === "1") {
      studeptlist().then((res) => {
        if (res.status === true) {
          setDeptList(res.data);
        }
      });

      // roleList().then((res) => {
      //   if (res.status === true) {
      //     setWtList(res.data);
      //   }
      // });

      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].id,
                label:
                  res.data.details[i].name + " - " + res.data.details[i].code,
              });
            }
            setACList(arr);
          }
        }
      });

      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                if (arr.length > 0) {
                  setAcaID(arr[0]);
                  listyear(arr[0]);
                  setAYear(localStorage.getItem("AYear"));
                }
              }
             
            }
          }
        });
      }else{
        listyear("");
      }


    } else if (localStorage.getItem("Role") === "4") {
      setIdType(4);
      studentviewdetail(localStorage.getItem("UID")).then((res) => {
        if (res.status === true) {
          filterstu(res.data.details.academy_id, res.data.details.academicyear, res.data.details.class_id, res.data.details.section_id);
        }
      })
      listyear("")
    }
  }, []);

  function handleAcademy(e) {
    if (idtype !== "") {
      if (e !== null) {
        setAcaID(e);
        listyear(e);
        if (idtype == 4) {
          filterstu(e, ayear, stucls, studiv);
        } else if (idtype == 5) {
          filtertea(e, dept);
        } else if (idtype > 6) {
          filterwor(e, wtype);
        }
      } else {
        setAcaID("");
        listyear("");
        if (idtype == 4) {
          filterstu("", ayear, stucls, studiv);
        } else if (idtype == 5) {
          filtertea(e, dept);
        } else if (idtype > 6) {
          filterwor(e, wtype);
        }
      }
    } else {
      toast.error("Please Select ID Card Type");
    }
  }
  function listyear(aid) {
    setAList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].aca_year,
            });
          }
        }
        setAList(arr);
      }
    });
  }
  function filterstu(aca, yr, cl, se) {
    setSList([]);
    setStuList([]);
    setSPath("");
    setStuId("");
    setAYear(yr);
    setStuCls(cl);
    setStuDiv(se);
    if (yr !== "" && cl !== "" && se !== "") {
      const temp = new FormData();
      temp.append("year", yr);
      temp.append("class", cl);
      temp.append("section", se);
      if (localStorage.getItem("Role") === "1" && aca !== "") {
        temp.append("academy", aca.value);
      }
      studentfilter(temp).then((res) => {
        if (res.status === true) {
          let arr = [];
          setSPath(res.data.path);
          if (localStorage.getItem("Role") !== "4") {
            setSList(res.data.details);
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].username +
                    " - " +
                    res.data.details[i].student_name,
                });
              }
            }
            setStuList(arr);
          } else if (localStorage.getItem("Role") === "4") {
            const sdata = res.data.details.filter((item) => item.user_id == localStorage.getItem("UID"));
            setSList(sdata);
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].user_id == localStorage.getItem("UID")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].username +
                      " - " +
                      res.data.details[i].student_name,
                  });
                }

              }
            }
            setStuList(arr);
            setStuId(arr[0]);
          }


        }
      });
    }
  }

  function handleStu(e) {
    if (e !== null) {
      setStuId(e);
    } else {
      setStuId("");
    }
  }

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  }

  function filtertea(aca, dep) {
    setTeaList([]);
    setTList([]);
    setSPath("");
    setStuId("");
    setDept(dep);
    if (dep !== "") {
      const temp = new FormData();
      temp.append("dept", dep);
      if (localStorage.getItem("Role") === "1" && aca !== "") {
        temp.append("academy", aca.value);
      }
      teacherfilter(temp).then((res) => {
        if (res.status === true) {
          let arr = [];
          setSPath(res.data.path);
          setTList(res.data.details);
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].id,
                label: res.data.details[i].username + " - " + res.data.details[i].teacher_name,
              });
            }
          }
          setTeaList(arr);
        }
      });
    }
  }


  function filterwor(aca, dep) {
    setWorList([]);
    setWoList([]);
    setSPath("");
    setStuId("");
    setWType(dep);
    if (dep !== "") {
      const temp = new FormData();
      temp.append("type", dep);
      if (localStorage.getItem("Role") === "1" && aca !== "") {
        temp.append("academy", aca.value);
      }
      workerfilter(temp).then((res) => {
        if (res.status === true) {
          let arr = [];
          setSPath(res.data.path);
          setWoList(res.data.details);
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].id,
                label: res.data.details[i].username + " - " + res.data.details[i].worker_name,
              });
            }
          }
          setWorList(arr);
        }
      });
    }
  }

  function stusubmit(e) {
    e.preventDefault();
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        toast.error("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }

    if (valid === "") {
      if (stuid !== "") {
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
          temp.append("academy_id", acaid.value);
        }
        temp.append("id", stuid.value);
        temp.append("role", idtype);

        stuidcardissue(temp).then((res) => {
          if (res.status === true) {
            setStuId("");
            filtertea(acaid, dept);
            toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        });
      }
    }

  }

  function handleType(e) {
    setIdType(e.target.value)
    setAYear("");
    setStuCls("");
    setStuDiv("");
    setStuId("");
    setDept("");
    setWType("");
    setSList([]);
    setStuList([]);
    setTList([]);
    setTeaList([]);
    setWoList([]);
    setWorList([]);
    if (e.target.value > 5) {
      filterwor('', e.target.value);
    }
  }
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Add ID Card</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>ID Card</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Add ID Card
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          {(localStorage.getItem("Role") === "1" || localStorage.getItem("Role") === "7") && (
            <div className="card">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5"> ID Card</h2>{" "}
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        ID Card Type<span className="text-danger"> *</span>
                      </label>
                      <select
                        className="default-select  form-control wide"
                        onChange={handleType}
                        value={idtype}
                      >
                        <option value="" disabled>
                          Select ID Card Type
                        </option>
                        {rlist.map((item) => (
                          <>
                            {item.id > 2 && (
                              <option value={item.id} key={item.id}>
                                {item.name}
                              </option>
                            )}
                          </>
                        ))}
                      </select>
                    </div>
                  </div>

                  {localStorage.getItem("Role") === "1" && (
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Select Academy <span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Academy"
                          value={acaid}
                          options={aclist}
                          onChange={handleAcademy}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                      </div>
                    </div>
                  )}

                  {idtype == 4 && (
                    <>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-6">
                          <label className="form-label">
                            Academic Year<span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select form-control wide"
                            onChange={(e) =>
                              filterstu(acaid, e.target.value, stucls, studiv)
                            }
                            value={ayear}
                          >
                            <option value="" disabled>
                              Select Academic Year
                            </option>
                            {alist.map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-6">
                          <label className="form-label">
                            Select Class<span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select form-control wide"
                            onChange={(e) =>
                              filterstu(acaid, ayear, e.target.value, studiv)
                            }
                            value={stucls}
                          >
                            <option value="" disabled>
                              Select Class
                            </option>
                            {clist.map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-6">
                          <label className="form-label">
                            Select Section<span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select form-control wide"
                            onChange={(e) =>
                              filterstu(acaid, ayear, stucls, e.target.value)
                            }
                            value={studiv}
                          >
                            <option value="" disabled>
                              Select Section
                            </option>
                            {dlist.map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Student Name
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Student"
                            value={stuid}
                            options={stulist}
                            onChange={handleStu}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {idtype == 5 && (
                    <>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Department <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select form-control wide"
                            value={dept}
                            onChange={(e) => filtertea(acaid, e.target.value)}
                          >
                            <option value="" disabled>
                              Select Department
                            </option>

                            {dplist.map((item) => {
                              return (
                                <option value={item.id} key={item.id}>
                                  {item.dept_name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Teacher Name{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Teacher"
                            value={stuid}
                            options={tealist}
                            onChange={handleStu}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                    </>
                  )}


                  {idtype > 5 && (
                    <>
                      {/* <div className="col-xl-4 col-sm-4">
                       <div className="mb-3">
                         <label className="form-label">
                           Workers Type <span className="text-danger"> *</span>
                         </label>
                         <select
                           className="default-select form-control wide"
                           value={wtype}
                           onChange={(e) => filterwor(acaid, e.target.value)}
                         >
                           <option value="" disabled>
                             Select Workers Type
                           </option>
 
                           {wlist.map((item) => {
                             return (
                               <option value={item.id} key={item.id}>
                                 {item.type_name}
                               </option>
                             );
                           })}
                         </select>
                       </div>
                     </div> */}

                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Worker Name{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Worker"
                            value={stuid}
                            options={Worlist}
                            onChange={handleStu}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )

          }

          {slist.map((item) => {
            if (item.id == stuid.value) {
              return (
                <>
                  <Card className="custom-card" key={item.id}>
                    <Card.Body>
                      {item.idcard_status == 1 && (
                        <div className="mt-2 text-center">
                          <span className="tx-18 text-success">
                            ID Card has already been issued.
                          </span>
                        </div>
                      )}
                      {item.idcard_status == 0 && localStorage.getItem('Role') == 4 && (
                        <div className="mt-2 text-center">
                          <span className="tx-18 text-danger">
                            ID Card has not issued.
                          </span>
                        </div>
                      )}
                      <div className="panel profile-cover">
                        <div className="profile-cover__img">
                          <img
                            src={spath + item.photo}
                            onError={(e) => errorphoto(e)}
                            alt="Student"
                          />
                          <h3 className="h3">{item.student_name}</h3>
                          <h3 className="h3 text-danger">
                            ( {item.username} )
                          </h3>
                        </div>

                        <div className="profile-cover__action bg-img"></div>
                        <div className="profile-cover__info">
                          <ul className="nav">
                            <li>
                              <strong>
                                {moment(item.date_of_birth).format(
                                  "DD-MM-YYYY"
                                )}
                              </strong>
                              DOB
                            </li>
                            <li>
                              <strong>{item.gender}</strong>Gender
                            </li>
                            <li>
                              <strong>{item.class_name}</strong>Class
                            </li>
                            <li>
                              <strong>{item.section_name}</strong>Section
                            </li>
                            <li>
                              <strong>{item.blood_name}</strong>Blood Group
                            </li>
                          </ul>
                        </div>
                      </div>

                      {item.idcard_status == 0 && localStorage.getItem("Role") == 1 && (
                        <div className="res-right mt-2 me-4">
                          <button
                            className="btn btn-success"
                            onClick={stusubmit}
                          >
                            Submit
                          </button>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </>
              );
            }
          })}


          {tlist.map((item) => {
            if (item.id == stuid.value) {
              return (
                <>
                  <Card className="custom-card" key={item.id}>
                    <Card.Body>
                      {item.idcard_status == 1 && (
                        <div className="mt-2 text-center">
                          <span className="tx-18 text-success">
                            ID Card has already been issued.
                          </span>
                        </div>
                      )}
                      <div className="panel profile-cover">
                        <div className="profile-cover__img">
                          <img
                            src={spath + item.photo}
                            onError={(e) => errorphoto(e)}
                            alt="Student"
                          />
                          <h3 className="h3">{item.teacher_name}</h3>
                          <h3 className="h3 text-danger">
                            ( {item.username} )
                          </h3>
                        </div>

                        <div className="profile-cover__action bg-img"></div>
                        <div className="profile-cover__info">
                          <ul className="nav">
                            <li>
                              <strong>
                                {moment(item.date_of_birth).format(
                                  "DD-MM-YYYY"
                                )}
                              </strong>
                              DOB
                            </li>
                            <li>
                              <strong>{item.gender}</strong>Gender
                            </li>
                            <li>
                              <strong>{item.department}</strong>Department
                            </li>
                            <li>
                              <strong>{item.class_name}</strong>Class
                            </li>

                            <li>
                              <strong>{item.blood_name}</strong>Blood Group
                            </li>
                          </ul>
                        </div>
                      </div>

                      {item.idcard_status == 0 && (
                        <div className="res-right mt-2 me-4">
                          <button
                            className="btn btn-success"
                            onClick={stusubmit}
                          >
                            Submit
                          </button>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </>
              );
            }
          })}


          {wolist.map((item) => {
            if (item.id == stuid.value) {
              return (
                <>
                  <Card className="custom-card" key={item.id}>
                    <Card.Body>
                      {item.idcard_status == 1 && (
                        <div className="mt-2 text-center">
                          <span className="tx-18 text-success">
                            ID Card has already been issued.
                          </span>
                        </div>
                      )}
                      <div className="panel profile-cover">
                        <div className="profile-cover__img">
                          <img
                            src={spath + item.worker_photo}
                            onError={(e) => errorphoto(e)}
                            alt="Student"
                          />
                          <h3 className="h3">{item.worker_name}</h3>
                          <h3 className="h3 text-danger">
                            ( {item.username} )
                          </h3>
                        </div>

                        <div className="profile-cover__action bg-img"></div>
                        <div className="profile-cover__info">
                          <ul className="nav">
                            <li>
                              <strong>
                                {moment(item.dob).format(
                                  "DD-MM-YYYY"
                                )}
                              </strong>
                              DOB
                            </li>
                            <li>
                              <strong>{item.gender}</strong>Gender
                            </li>
                            <li>
                              <strong>{item.type_name}</strong>Department
                            </li>
                            <li>
                              <strong>{item.blood_name}</strong>Blood Group
                            </li>
                          </ul>
                        </div>
                      </div>

                      {item.idcard_status == 0 && (
                        <div className="res-right mt-2 me-4">
                          <button
                            className="btn btn-success"
                            onClick={stusubmit}
                          >
                            Submit
                          </button>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
}
